import React from 'react'

const Publications = () => { }
export default Publications